import { render, staticRenderFns } from "./BorrowerProfile.vue?vue&type=template&id=740b9d68&"
import script from "./BorrowerProfile.vue?vue&type=script&lang=js&"
export * from "./BorrowerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports